import { render } from "./VoiceMessageBubble.vue?vue&type=template&id=ff07dbf0&scoped=true"
import script from "./VoiceMessageBubble.vue?vue&type=script&lang=js"
export * from "./VoiceMessageBubble.vue?vue&type=script&lang=js"

import "./VoiceMessageBubble.vue?vue&type=style&index=0&id=ff07dbf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff07dbf0"]])

export default __exports__